import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{this._svg}}\n",{ moduleName: "sh-www/components/inline-svg.hbs" })